export { default } from './document-controller';
